module.exports = __webpack_public_path__ + "static/media/Host Asset 7.28c7784a.svg";